// // Simple function to hide links using wlm.arrHideLinks
(function () {
    function hideLockedProducts() {
        if (!window.wlm || !Array.isArray(window.wlm.arrHideLinks)) return;

        window.wlm.arrHideLinks.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (el) {
                const product = el.closest('.block.product');

                if (product) {
                    product.style.setProperty('display', 'none', 'important');
                }
            });
        });
    }

    // Initial run
    hideLockedProducts();

    // Run whenever search results change
    const observer = new MutationObserver(function () {
        hideLockedProducts();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();